// axios
import axios from 'axios'
// const baseURL = "https://confi.mbsi.com.ph"
// const baseURL = "https://staff.mbsi.com.ph"
// const baseURL = "https://staff.mbsi.com.ph"
// const baseURL = "https://dev-test.mbsi.com.ph"
// const baseURL = "https://teststaff.mbsi.com.ph"
// const baseURL = "https://localhost:5001"
// const baseURL = "https://oberthur.mbsi.com.ph"
// const baseURL = "https://cushman.mbsi.com.ph"
// const baseURL = "https://galderma.mbsi.com.ph"
// const baseURL = "https://fonterra.mbsi.com.ph"
// const baseURL = "https://virbac.mbsi.com.ph"
// const baseURL = "https://autodesk.mbsi.com.ph"
// const baseURL = "https://sandvikph.mbsi.com.ph"
// const baseURL = "https://sandviktamrock.mbsi.com.ph"
// const baseURL = "https://hubvantage.mbsi.com.ph"
// const baseURL = "https://evaair.mbsi.com.ph"
const baseURL = "https://dileonardo.mbsi.com.ph"
// const baseURL = "https://localhost:5001"
export default axios.create({
  baseURL: baseURL
  // You can add your headers here
})
